// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================
   DESIGN TOKENS — Pyate Blue Brand
====================================== */
:root {
  --brand:          #1565C0;
  --brand-mid:      #1976D2;
  --brand-light:    #42A5F5;
  --brand-soft:     #E8F1FB;
  --brand-glow:     rgba(21, 101, 192, 0.15);
  --surface:        #ffffff;
  --surface-2:      #F5F7FA;
  --page-bg:        #F0F2F5;
  --border:         #DCE8F8;
  --border-strong:  #BBCFF5;
  --text-primary:   #0C1A2E;
  --text-secondary: #334D6E;
  --text-muted:     #7090B0;
  --font:           'Plus Jakarta Sans', sans-serif;
  --ease:           cubic-bezier(0.16, 1, 0.3, 1);
  --radius-md:      14px;
  --radius-lg:      20px;
  --shadow-sm:      0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(21,101,192,0.06);
  --shadow-md:      0 4px 16px rgba(0,0,0,0.08), 0 12px 32px rgba(21,101,192,0.09);
}

* { box-sizing: border-box; }

/* ======================================
   POSTS CONTAINER
====================================== */
.card-container-edit-store {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 20px;
  font-family: var(--font);
  font-size: 14px;
  width: 95%;
  max-width: 860px;
  margin: 20px auto;
  background: transparent;
}

/* ======================================
   POST CARD
====================================== */
.card-container-edit-store > * {
  width: 100%;
}

/* If individual post cards exist */
.post-card-store,
.card-edit-store {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  margin-bottom: 18px;
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  transition: transform 0.24s var(--ease), box-shadow 0.24s var(--ease), border-color 0.2s;
  position: relative;
}

/* Blue accent stripe on hover */
.post-card-store::before,
.card-edit-store::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 100%);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.24s var(--ease);
}

.post-card-store:hover::before,
.card-edit-store:hover::before {
  transform: scaleX(1);
}

.post-card-store:hover,
.card-edit-store:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-md);
  border-color: var(--border-strong);
}

/* ======================================
   RESPONSIVE
====================================== */
@media (max-width: 900px) {
  .card-container-edit-store {
    width: 95%;
    padding: 16px 14px;
    font-size: 13px;
    max-width: 100%;
    margin: 12px auto;
  }
}

@media (max-width: 600px) {
  .card-container-edit-store {
    width: 100%;
    padding: 10px 8px;
    font-size: 12.5px;
    margin: 8px 0;
    max-width: 100%;
  }
}
/* ======================================
   NO POSTS EMPTY STATE
====================================== */
.no-posts-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  width: 100%;
}

.no-posts-icon {
  font-size: 48px;
  margin-bottom: 14px;
  color: var(--text-muted);
}

.no-posts-state h3 {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 8px;
}

.no-posts-state p {
  font-size: 14px;
  color: var(--text-muted);
  margin: 0;
}

/* ======================================
   MODERN COMMENTS UI (MATCHES STORE DESIGN)
====================================== */

.comments-window-edit {
  background: var(--surface);
  border-top: 1px solid var(--border);
  padding: 16px;
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
}

/* Header */
.comments-header-edit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
}

.comments-header-edit h3 {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
}

.close-btn-edit {
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: var(--text-muted);
  transition: all 0.2s ease;
}

.close-btn-edit:hover {
  background: var(--brand-soft);
  border-color: var(--brand-light);
  color: var(--brand);
}

/* Comment list */
.comments-list-edit {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 300px;
  overflow-y: auto;
  padding-right: 4px;
}

/* Scrollbar styling */
.comments-list-edit::-webkit-scrollbar {
  width: 6px;
}

.comments-list-edit::-webkit-scrollbar-track {
  background: transparent;
}

.comments-list-edit::-webkit-scrollbar-thumb {
  background: var(--border-strong);
  border-radius: 3px;
}

.comments-list-edit::-webkit-scrollbar-thumb:hover {
  background: var(--brand-light);
}

/* Individual comment */
.comment-card-new {
  display: flex;
  gap: 12px;
  padding: 12px 14px;
  border-radius: var(--radius-md);
  background: var(--surface-2);
  border: 1px solid var(--border);
  transition: all 0.2s var(--ease);
  position: relative;
}

.comment-card-new:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
  border-color: var(--border-strong);
}

/* Avatar */
.comment-avatar-new {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid var(--brand-soft);
}

/* Content */
.comment-content-new {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  min-width: 0; /* Allow text to wrap */
}

/* Username */
.comment-username-new {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 2px;
}

/* Comment text */
.comment-text-new {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.5;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* ======================================
   COMMENT INPUT (MODERN)
====================================== */

.comments-form-edit {
  margin-top: 16px;
}

.comment-input-modern {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 8px 12px;
  transition: border-color 0.2s ease;
}

.comment-input-modern:focus-within {
  border-color: var(--brand-light);
  box-shadow: 0 0 0 3px var(--brand-glow);
}

.comment-input-modern input {
  flex: 1 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  padding: 8px 0;
  color: var(--text-primary);
  font-family: var(--font);
}

.comment-input-modern input::placeholder {
  color: var(--text-muted);
}

.comment-input-modern button {
  background: linear-gradient(135deg, var(--brand), var(--brand-mid));
  border: none;
  color: white;
  border-radius: 999px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s var(--ease);
  font-family: var(--font);
}

.comment-input-modern button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px var(--brand-glow);
}

.comment-input-modern button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* ======================================
   EMOJI PICKER FIX
====================================== */

/* Emoji button */
.emoji-btn-new {
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 6px;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.emoji-btn-new:hover {
  background-color: rgba(21, 101, 192, 0.1);
}

/* Emoji picker container */
.emoji-picker-modern {
  position: absolute;
  bottom: 60px;
  right: 10px;
  z-index: 1000;
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-md);
  padding: 8px;
  max-width: 300px;
}

/* Emoji picker close button */
.emoji-picker-close {
  position: absolute;
  top: 8px;
  right: 8px;
  background: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: var(--text-muted);
  transition: all 0.2s ease;
  z-index: 1001;
}

.emoji-picker-close:hover {
  background: var(--brand-soft);
  border-color: var(--brand-light);
  color: var(--brand);
}`, "",{"version":3,"sources":["webpack://./src/components/Posts.css"],"names":[],"mappings":"AAEA;;wCAEwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;EACjD,+CAA+C;EAC/C,sBAAsB;EACtB,sBAAsB;EACtB,8EAA8E;EAC9E,gFAAgF;AAClF;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;wCAEwC;AACxC;EACE,WAAW;AACb;;AAEA,mCAAmC;AACnC;;EAEE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,wFAAwF;EACxF,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,4EAA4E;EAC5E,oBAAoB;EACpB,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;;wCAEwC;AACxC;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,eAAe;EACjB;AACF;AACA;;wCAEwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,SAAS;AACX;;AAEA;;wCAEwC;;AAExC;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,aAAa;EACb,oDAAoD;AACtD;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mCAAmC;AACrC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY,EAAE,uBAAuB;AACvC;;AAEA,aAAa;AACb;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;wCAEwC;;AAExC;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mEAAmE;EACnE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;wCAEwC;;AAExC,iBAAiB;AACjB;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,4BAA4B;EAC5B,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');\n\n/* ======================================\n   DESIGN TOKENS — Pyate Blue Brand\n====================================== */\n:root {\n  --brand:          #1565C0;\n  --brand-mid:      #1976D2;\n  --brand-light:    #42A5F5;\n  --brand-soft:     #E8F1FB;\n  --brand-glow:     rgba(21, 101, 192, 0.15);\n  --surface:        #ffffff;\n  --surface-2:      #F5F7FA;\n  --page-bg:        #F0F2F5;\n  --border:         #DCE8F8;\n  --border-strong:  #BBCFF5;\n  --text-primary:   #0C1A2E;\n  --text-secondary: #334D6E;\n  --text-muted:     #7090B0;\n  --font:           'Plus Jakarta Sans', sans-serif;\n  --ease:           cubic-bezier(0.16, 1, 0.3, 1);\n  --radius-md:      14px;\n  --radius-lg:      20px;\n  --shadow-sm:      0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(21,101,192,0.06);\n  --shadow-md:      0 4px 16px rgba(0,0,0,0.08), 0 12px 32px rgba(21,101,192,0.09);\n}\n\n* { box-sizing: border-box; }\n\n/* ======================================\n   POSTS CONTAINER\n====================================== */\n.card-container-edit-store {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 20px;\n  font-family: var(--font);\n  font-size: 14px;\n  width: 95%;\n  max-width: 860px;\n  margin: 20px auto;\n  background: transparent;\n}\n\n/* ======================================\n   POST CARD\n====================================== */\n.card-container-edit-store > * {\n  width: 100%;\n}\n\n/* If individual post cards exist */\n.post-card-store,\n.card-edit-store {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  margin-bottom: 18px;\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  transition: transform 0.24s var(--ease), box-shadow 0.24s var(--ease), border-color 0.2s;\n  position: relative;\n}\n\n/* Blue accent stripe on hover */\n.post-card-store::before,\n.card-edit-store::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-light) 100%);\n  transform: scaleX(0);\n  transform-origin: left;\n  transition: transform 0.24s var(--ease);\n}\n\n.post-card-store:hover::before,\n.card-edit-store:hover::before {\n  transform: scaleX(1);\n}\n\n.post-card-store:hover,\n.card-edit-store:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-md);\n  border-color: var(--border-strong);\n}\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n@media (max-width: 900px) {\n  .card-container-edit-store {\n    width: 95%;\n    padding: 16px 14px;\n    font-size: 13px;\n    max-width: 100%;\n    margin: 12px auto;\n  }\n}\n\n@media (max-width: 600px) {\n  .card-container-edit-store {\n    width: 100%;\n    padding: 10px 8px;\n    font-size: 12.5px;\n    margin: 8px 0;\n    max-width: 100%;\n  }\n}\n/* ======================================\n   NO POSTS EMPTY STATE\n====================================== */\n.no-posts-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  width: 100%;\n}\n\n.no-posts-icon {\n  font-size: 48px;\n  margin-bottom: 14px;\n  color: var(--text-muted);\n}\n\n.no-posts-state h3 {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 8px;\n}\n\n.no-posts-state p {\n  font-size: 14px;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n/* ======================================\n   MODERN COMMENTS UI (MATCHES STORE DESIGN)\n====================================== */\n\n.comments-window-edit {\n  background: var(--surface);\n  border-top: 1px solid var(--border);\n  padding: 16px;\n  border-radius: 0 0 var(--radius-lg) var(--radius-lg);\n}\n\n/* Header */\n.comments-header-edit {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border);\n}\n\n.comments-header-edit h3 {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.close-btn-edit {\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  color: var(--text-muted);\n  transition: all 0.2s ease;\n}\n\n.close-btn-edit:hover {\n  background: var(--brand-soft);\n  border-color: var(--brand-light);\n  color: var(--brand);\n}\n\n/* Comment list */\n.comments-list-edit {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  max-height: 300px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n\n/* Scrollbar styling */\n.comments-list-edit::-webkit-scrollbar {\n  width: 6px;\n}\n\n.comments-list-edit::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.comments-list-edit::-webkit-scrollbar-thumb {\n  background: var(--border-strong);\n  border-radius: 3px;\n}\n\n.comments-list-edit::-webkit-scrollbar-thumb:hover {\n  background: var(--brand-light);\n}\n\n/* Individual comment */\n.comment-card-new {\n  display: flex;\n  gap: 12px;\n  padding: 12px 14px;\n  border-radius: var(--radius-md);\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  transition: all 0.2s var(--ease);\n  position: relative;\n}\n\n.comment-card-new:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n  border-color: var(--border-strong);\n}\n\n/* Avatar */\n.comment-avatar-new {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n  border: 2px solid var(--brand-soft);\n}\n\n/* Content */\n.comment-content-new {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0; /* Allow text to wrap */\n}\n\n/* Username */\n.comment-username-new {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 2px;\n}\n\n/* Comment text */\n.comment-text-new {\n  font-size: 14px;\n  color: var(--text-secondary);\n  line-height: 1.5;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n/* ======================================\n   COMMENT INPUT (MODERN)\n====================================== */\n\n.comments-form-edit {\n  margin-top: 16px;\n}\n\n.comment-input-modern {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: 999px;\n  padding: 8px 12px;\n  transition: border-color 0.2s ease;\n}\n\n.comment-input-modern:focus-within {\n  border-color: var(--brand-light);\n  box-shadow: 0 0 0 3px var(--brand-glow);\n}\n\n.comment-input-modern input {\n  flex: 1;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 14px;\n  padding: 8px 0;\n  color: var(--text-primary);\n  font-family: var(--font);\n}\n\n.comment-input-modern input::placeholder {\n  color: var(--text-muted);\n}\n\n.comment-input-modern button {\n  background: linear-gradient(135deg, var(--brand), var(--brand-mid));\n  border: none;\n  color: white;\n  border-radius: 999px;\n  padding: 8px 16px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.2s var(--ease);\n  font-family: var(--font);\n}\n\n.comment-input-modern button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px var(--brand-glow);\n}\n\n.comment-input-modern button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ======================================\n   EMOJI PICKER FIX\n====================================== */\n\n/* Emoji button */\n.emoji-btn-new {\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n}\n\n.emoji-btn-new:hover {\n  background-color: rgba(21, 101, 192, 0.1);\n}\n\n/* Emoji picker container */\n.emoji-picker-modern {\n  position: absolute;\n  bottom: 60px;\n  right: 10px;\n  z-index: 1000;\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-md);\n  padding: 8px;\n  max-width: 300px;\n}\n\n/* Emoji picker close button */\n.emoji-picker-close {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: var(--surface-2);\n  border: 1px solid var(--border);\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: var(--text-muted);\n  transition: all 0.2s ease;\n  z-index: 1001;\n}\n\n.emoji-picker-close:hover {\n  background: var(--brand-soft);\n  border-color: var(--brand-light);\n  color: var(--brand);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
